export { default } from './SectionHowItWorks';